import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./HeroButton.css";

const HeroButton = ({
  icon: Icon,
  children,
  onClick,
  to,
  variant = "primary",
  className = "",
  disabled = false,
  size = "md",
  outline = false,
}) => {
  const buttonProps = {
    variant: outline ? `outline-${variant}` : variant,
    className: `hero-button ${className} ${outline ? "outline" : ""}`,
    disabled,
    size,
    onClick,
  };

  const buttonContent = (
    <>
      {Icon && <Icon className="button-icon" />}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to}>
        <Button {...buttonProps}>{buttonContent}</Button>
      </Link>
    );
  }

  return <Button {...buttonProps}>{buttonContent}</Button>;
};

HeroButton.propTypes = {
  icon: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  outline: PropTypes.bool,
};

export default HeroButton;
